const global = {
    /*------------ 测试配置 ----------------*/
    // deviceLogUrl:'http://test.blackview4g.com:8800/device-upload/', // 设备日志、图片拼接路径

    //验证上传
    beforeAvatarUpload: function(file) {
        let _type = false;
        if(file.type === 'image/jpeg' || file.type === 'image/png'){
            _type = true;
        }
        let _size = file.size / 1024 / 1024 < 4;

        if(!_type) this.$message.error('上传头像图片只能是JPG/PNG格式');

        if(!_size) this.$message.error('上传头像图片大小不能超过4MB');
        return _type && _size;
    },

    //日期格式化
    dateFormatter: function(){
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    msg:function(val){
        this.$notify.info({
            title: '提示',
            duration: 2000,
            message: val
        });
    },
    errorMsg:function(val){
        this.$notify.error({
            title: '提示',
            duration: 2000,
            message: val
        });
    },
    clearObj(obj){
        for(let key in obj){
            obj[key]=''
        }
    },
    dealStr(str){
        let length = str.length;
        if (length>15){
            let a = str.replace(/<[^>]+>/g,"").substr(0,25)+"...";
            return a;
        }
        return str.replace(/<[^>]+>/g,"");
    },
    isAdmin(){
        let role = localStorage.getItem("blackview-user");
        return JSON.parse(role).role === "admin";
    },
    dealFileUrl(url){
        let length = url.indexOf(".com");
        if (length>-1){
            return  url.substr(length+5);
        }
        return url;
    },

    notIsEmpty(val){
        let flag = true;
        if (val === "" || val=== null || val === 'null' || typeof(val)=== "undefined" ) {
            flag = false;
        }
        return flag;
    },
    dealObject(obj){
        let params ="";
        let flag= true;
        for(let key in obj){
            let value = obj[key];
            if ( null !== value) {
                value = value.toString();
                /**
                 * 将后台返回的完整的url 截取具体链接如：/head/12.png
                 * @param {图片或视频后台返回完整的URl} val
                 */
                if(value.indexOf("aliyuncs.com")>-1){
                    value = value.slice(value.indexOf("aliyuncs.com/")+13,value.indexOf("?"))
                }
            }
            if(flag){
                params=key+"="+value;
                flag = false;
            }else{
                params+="&"+key+"="+value;
            }
        }
        return params;
    }
}
export default global;
